import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Grid,
  Button,
  Typography,
  TextField,
  Divider,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  Autocomplete,
  FormGroup,
  Switch,
  Modal,
  Card,
} from "@mui/material";
import CustomTable from "../../components/table/Table";
import { useDispatch, useSelector } from "react-redux";
import SearchButton from "../../components/search/Search";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloudUpload from "../../components/button/Cloudupload";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { getregion } from "../../slices/setting";
import { createcustomer, createinvoice, createpayment, getinvoicebycus, getinvoicebyid, getpaymentbycus, getpaymentbyid, updateinvoicebyid } from "../../slices/customer";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { getpurchase } from "../../slices/purchase";
import BasicTabs from "../../components/tabs/Invitab";
import { deleteproductstock, getproductstock } from "../../slices/inventory";
import DeleteIcon from "@mui/icons-material/Delete";
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import CustomTable2 from "../../components/table/paytable";
import { useReactToPrint } from 'react-to-print';
import { getquotebyid } from "../../slices/quote";

const columns2 = [
  { id: 'payment_id', label: 'Payment ID', minWidth: 200, align:'start' },
  { id: 'invoice_id', label: 'Invoice ID', minWidth: 150, align:'center' },
  { id: 'total', label: 'Amount', minWidth: 150, align:'center' },
  { id: 'status', label: 'Status', minWidth: 150, align:'center' },
  // { id: 'action', label: 'Action', minWidth: 100, align:'end', actionType: [{edit: true, delete: false}] },
];


const Viewquote = ({ setLoader, show }) => {

  const componentRef = useRef();

  const {state} = useLocation();

  const params = useParams()

  const {getQuote: quotes} = useSelector((state) => state.quote) || [];

  const paymentData = quotes !== "" && quotes?.map((va)=>{
    return{
      ...va,
      created_at: `${(new Date(va.created_at)).getDate()} / ${(new Date(va.created_at)).getMonth()+1} / ${(new Date(va.created_at)).getFullYear()}`,
    }
  });

  const user = JSON.parse(localStorage.getItem('user'));

  const dealerState =  JSON.parse(user.billing_address).state; 

  console.log(state.viewData, paymentData, user);


  const dispatch = useDispatch();

  const navigate = useNavigate();

  const arrowBack = () => {
    navigate(-1);
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  React.useEffect(()=>{
    setLoader(true)
    const id = params.invoiceId;
      dispatch(getquotebyid(id))
      .then(() => {
        setLoader(false);
      })
      .catch(()=>{
        setLoader(false);
      })
  }, [])

  return (
    <div className="content" style={{ marginLeft: show ? "220px" : "10px", marginBottom:'150px'}}>
    <Grid container spacing={2}>
    <Grid
            item
            xs={6}
            sx={{
              paddingTop: 0,
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >

            <ArrowBackIcon onClick={arrowBack} sx={{ cursor: "pointer" }} />
            <Typography variant="h5">{params.invoiceId}</Typography>
          </Grid>
          <Grid
            item
            xs={6}
            onClick={handlePrint}
            sx={{
              paddingTop: 0,
              display: "flex",
              alignItems: "center",
              justifyContent:'end',
              gap: 1,
            }}
          >
            <LocalPrintshopOutlinedIcon sx={{ cursor: "pointer" }} />
            <Typography variant="h6">Print</Typography>
          </Grid>
    </Grid>
      <Box ref={componentRef} sx={{mt: 2, border:'1px solid #bababa', p: 3}}>
        <Grid container spacing={3} sx={{ paddingBottom: 2, alignItems: "center" }}>
        <Grid item xs={8} sx={{display:'flex', alignItems:'center', justifyContent:'start', gap: 2}}>
                <Typography><img src={user?.logo_url} width={100}></img></Typography>
                <Box>
                <Typography variant="h6">{user.organization_name}</Typography>
                <Typography >{Object.values(JSON.parse(user?.billing_address)).join(', ')}</Typography>
                <Typography >{user.contact}</Typography>
                </Box>
            </Grid>
        <Grid item xs={4} sx={{textAlign:'end'}}>
                <Typography variant="h6">Quotation</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Grid item xs={6}>
                <Typography >Billed to</Typography>
                <Typography variant="h6">{paymentData[0]?.customer_name}</Typography>
                <Typography >{paymentData[0]?.address}</Typography>
                <Typography >{paymentData[0]?.email}</Typography>
                <Typography >{paymentData[0]?.phone_no}</Typography>
                </Grid>
                <Grid item xs={6}  sx={{textAlign:'end'}}>
                <Typography >Date: {paymentData[0]?.created_at}</Typography>
                <Typography >Quote # : {paymentData[0]?.quote_id}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Grid item xs={12}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell rowSpan={2} sx={{background:'#595959', color:'#fff'}}>Items</TableCell>
            <TableCell rowSpan={2} align="center" sx={{background:'#595959', color:'#fff'}}>Rate</TableCell>
            <TableCell rowSpan={2} align="center" sx={{background:'#595959', color:'#fff'}}>Qty</TableCell>
            <TableCell rowSpan={2} align="center" sx={{background:'#595959', color:'#fff'}}>Price</TableCell>
            <TableCell colSpan={2} align="center" sx={{background:'#595959', color:'#fff'}}>SGST</TableCell>
            <TableCell colSpan={2} align="center" sx={{background:'#595959', color:'#fff'}}>CGST</TableCell>
            <TableCell colSpan={2} align="center" sx={{background:'#595959', color:'#fff'}}>IGST</TableCell>
            <TableCell rowSpan={2} align="right" sx={{background:'#595959', color:'#fff'}}>Amount</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{background:'#595959', color:'#fff'}}>%</TableCell>
            <TableCell align="center" sx={{background:'#595959', color:'#fff'}}>Amount</TableCell>
            <TableCell sx={{background:'#595959', color:'#fff'}}>%</TableCell>
            <TableCell align="center" sx={{background:'#595959', color:'#fff'}}>Amount</TableCell>
            <TableCell sx={{background:'#595959', color:'#fff'}}>%</TableCell>
            <TableCell align="center" sx={{background:'#595959', color:'#fff'}}>Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {paymentData[0]?.item_list && JSON.parse(paymentData[0]?.item_list).map((va, index) => {
          return(
            <TableRow key={index}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
                         {(va?.product_type === "Vehicle" || !va.hasOwnProperty("product_type")) ?
              <TableCell component="th" scope="row">
            {va?.vehicle?.product_name} <br></br>
{va?.variant?.variant_name} <br/>
              </TableCell>
              :
              va?.product_type === "Others" ?
              <TableCell component="th" scope="row">
              {va?.itemDetails}
              </TableCell>
              :
              <TableCell component="th" scope="row">
            {va?.vehicle?.product_name} <br></br>
Vehicle Model: {va?.variant?.variant_name} <br/>

Product Name: {va?.stock?.product} <br/>

Company: {va?.stock?.company} <br/>

Part Code: {va?.stock?.part_code} <br/>
              </TableCell>
            }
            { (va?.product_type === "Vehicle" || !va.hasOwnProperty("product_type")) ? 
            <TableCell >{JSON.parse(va.variant?.price_groups).filter(obj => obj.state === dealerState)[0]?.ex_showroom}</TableCell>
              :
              va?.product_type === "Spare" ?
              <TableCell >{va?.spare?.price}</TableCell>
              :
              va?.product_type === "Accessory" ?
              <TableCell >{va?.accessory?.price}</TableCell>
              :
              <TableCell >{va?.price}</TableCell>
            }
            <TableCell align="center">{va?.variant?.qty}</TableCell>
            <TableCell >{(JSON.parse(va.variant?.price_groups).filter(obj => obj.state === dealerState)[0]?.ex_showroom)*va?.variant?.qty}</TableCell>
            { (va?.product_type === "Vehicle" || !va.hasOwnProperty("product_type")) ? 
            <TableCell >{paymentData[0]?.sgst !== 0 ? (va?.vehicle?.sgst) : '-'}</TableCell>
              :
              va?.product_type === "Spare" ?
              <TableCell >{paymentData[0]?.sgst !== 0 ? (va?.spare?.sgst) : '-'}</TableCell>
              :
              va?.product_type === "Accessory" ?
              <TableCell >{paymentData[0]?.sgst !== 0 ? (va?.accessory?.sgst) : '-'}</TableCell>
              :
              <TableCell >{paymentData[0]?.sgst !== 0 ? (va?.sgst) : '-'}</TableCell>
            }
            { (va?.product_type === "Vehicle" || !va.hasOwnProperty("product_type")) ? 
            <TableCell >{paymentData[0]?.sgst !== 0 ? ((JSON.parse(va.variant?.price_groups).filter(obj => obj.state === dealerState)[0]?.ex_showroom*Number(va?.variant?.qty)) * (va.vehicle?.sgst/100)) : '-'}</TableCell>
              :
              va?.product_type === "Spare" ?
              <TableCell >{paymentData[0]?.sgst !== 0 ? (va?.spare?.price * (va.spare?.sgst/100)) : '-'}</TableCell>
              :
              va?.product_type === "Accessory" ?
              <TableCell >{paymentData[0]?.sgst !== 0 ? (va?.accessory?.price * (va.accessory?.sgst/100)) : '-'}</TableCell>
              :
              <TableCell >{paymentData[0]?.sgst !== 0 ? (va?.price * (va?.sgst/100)) : '-'}</TableCell>
            }
            { (va?.product_type === "Vehicle" || !va.hasOwnProperty("product_type")) ? 
            <TableCell >{paymentData[0]?.cgst !== 0 ? (va.vehicle?.cgst) : '-'}</TableCell>
              :
              va?.product_type === "Spare" ?
              <TableCell >{paymentData[0]?.cgst !== 0 ? (va.spare?.cgst) : '-'}</TableCell>
              :
              va?.product_type === "Accessory" ?
              <TableCell >{paymentData[0]?.cgst !== 0 ? (va.accessory?.cgst) : '-'}</TableCell>
              :
              <TableCell >{paymentData[0]?.cgst !== 0 ? (va?.cgst) : '-'}</TableCell>
            }
            { (va?.product_type === "Vehicle" || !va.hasOwnProperty("product_type")) ? 
            <TableCell >{paymentData[0]?.cgst !== 0 ? ((JSON.parse(va.variant?.price_groups).filter(obj => obj.state === dealerState)[0]?.ex_showroom*Number(va?.variant?.qty)) * (va.vehicle?.cgst/100)) : '-'}</TableCell>
              :
              va?.product_type === "Spare" ?
              <TableCell >{paymentData[0]?.cgst !== 0 ? (va?.spare?.price * (va.spare?.cgst/100)) : '-'}</TableCell>
              :
              va?.product_type === "Accessory" ?
              <TableCell >{paymentData[0]?.cgst !== 0 ? (va?.accessory?.price * (va.accessory?.cgst/100)) : '-'}</TableCell>
              :
              <TableCell >{paymentData[0]?.cgst !== 0 ? (va?.price * (va?.cgst/100)) : '-'}</TableCell>
            }
            { (va?.product_type === "Vehicle" || !va.hasOwnProperty("product_type")) ? 
            <TableCell >{paymentData[0]?.igst !== 0 ? (va.vehicle?.igst) : '-'}</TableCell>
              :
              va?.product_type === "Spare" ?
              <TableCell >{paymentData[0]?.igst !== 0 ? (va.spare?.igst) : '-'}</TableCell>
              :
              va?.product_type === "Accessory" ?
              <TableCell >{paymentData[0]?.igst !== 0 ? (va.accessory?.igst) : '-'}</TableCell>
              :
              <TableCell >{paymentData[0]?.igst !== 0 ? (va?.igst) : '-'}</TableCell>
            }
            { (va?.product_type === "Vehicle" || !va.hasOwnProperty("product_type")) ? 
            <TableCell >{paymentData[0]?.igst !== 0 ? ((JSON.parse(va.variant?.price_groups).filter(obj => obj.state === dealerState)[0]?.ex_showroom*Number(va?.variant?.qty)) * (va.vehicle?.igst/100)) : '-'}</TableCell>
              :
              va?.product_type === "Spare" ?
              <TableCell >{paymentData[0]?.igst !== 0 ? (va?.spare?.price * (va.spare?.igst/100)) : '-'}</TableCell>
              :
              va?.product_type === "Accessory" ?
              <TableCell >{paymentData[0]?.igst !== 0 ? (va?.accessory?.price * (va.accessory?.igst/100)) : '-'}</TableCell>
              :
              <TableCell >{paymentData[0]?.igst !== 0 ? (va?.price * (va?.igst/100)) : '-'}</TableCell>
            }
            { (va?.product_type === "Vehicle" || !va.hasOwnProperty("product_type"))? 
            <TableCell >{(paymentData[0]?.sgst !== 0 || paymentData[0]?.cgst !== 0 || paymentData[0]?.igst !== 0) ? (Number(JSON.parse(va.variant?.price_groups).filter(obj => obj.state === dealerState)[0]?.ex_showroom*Number(va?.variant?.qty))+Number(JSON.parse(va.variant?.price_groups).filter(obj => obj.state === dealerState)[0]?.ex_showroom*Number(va?.variant?.qty) * (va.vehicle?.sgst/100))+Number(JSON.parse(va.variant?.price_groups).filter(obj => obj.state === dealerState)[0]?.ex_showroom*Number(va?.variant?.qty) * (va.vehicle?.cgst/100))+Number(JSON.parse(va.variant?.price_groups).filter(obj => obj.state === dealerState)[0]?.ex_showroom*Number(va?.variant?.qty) * (va.vehicle?.igst/100))) : Number(JSON.parse(va.variant?.price_groups).filter(obj => obj.state === dealerState)[0]?.ex_showroom)*Number(va?.variant?.qty)}</TableCell>             :
              va?.product_type === "Spare" ?
              <TableCell >{(paymentData[0]?.sgst !== 0 || paymentData[0]?.cgst !== 0 || paymentData[0]?.igst !== 0) ? (Number(va?.spare?.price)+Number((va?.spare?.price) * (va?.spare?.sgst/100))+Number((va?.spare?.price) * (va?.spare?.cgst/100))+Number((va?.spare?.price) * (va?.spare?.igst/100))) : Number(va?.spare?.price)}</TableCell>
                :
                va?.product_type === "Accessory" ?
                <TableCell >{(paymentData[0]?.sgst !== 0 || paymentData[0]?.cgst !== 0 || paymentData[0]?.igst !== 0) ? (Number(va?.accessory?.price)+Number((va?.accessory?.price) * (va?.accessory?.sgst/100))+Number((va?.accessory?.price) * (va?.accessory?.cgst/100))+Number((va?.accessory?.price) * (va?.accessory?.igst/100))) : Number(va?.accessory?.price)}</TableCell>           
                :
                <TableCell >{(paymentData[0]?.sgst !== 0 || paymentData[0]?.cgst !== 0 || paymentData[0]?.igst !== 0) ? (Number(va?.price)+Number((va?.price) * (va?.sgst/100))+Number((va?.price) * (va?.cgst/100))+Number((va?.price) * (va?.igst/100))) : Number(va?.price)}</TableCell>  
                 }
              
            </TableRow>
          )
        })}
        </TableBody>
              </Table>
                </Grid>
                <Grid item xs={12}>
                <Divider sx={{mb: 2}}/>           
                </Grid>
                <Grid item xs={6}>

                </Grid>
            <Grid item xs={6} sx={{p: 2, background:'#eaeaea', textAlign:'end'}}>
            <Grid container spacing={2}>
          <Grid item xs={6} sx={{textAlign:'end'}}>
              <Typography variant="body1" sx={{mb: 1}}>Sub Total</Typography>
              <Typography variant="body1" sx={{mb: 1}}>Fabrication</Typography>
              <Typography variant="body1" sx={{mb: 1}}>RTO</Typography>
              <Typography variant="body1" sx={{mb: 1}}>Insurance</Typography>
              <Typography variant="body1" sx={{mb: 1}}>Local Body Tax</Typography>
              <Typography  variant="body1"  sx={{mb: 1}}>Adjustment</Typography>
              <Typography  variant="body1"  sx={{mb: 1}}>GST</Typography>
              <Typography  variant="h6">Total Amount</Typography>
          </Grid>
          <Grid item xs={6} sx={{textAlign:'end'}}>
              <Typography variant="body1" sx={{mb: 1}}>₹ {paymentData[0]?.sub_total}</Typography>
              <Typography variant="body1" sx={{mb: 1}}>₹ {paymentData[0]?.fabrication}</Typography>
              <Typography variant="body1" sx={{mb: 1}}>₹ {paymentData[0]?.rto}</Typography>
              <Typography variant="body1" sx={{mb: 1}}>₹ {paymentData[0]?.insurance}</Typography>
              <Typography variant="body1" sx={{mb: 1}}>₹ {paymentData[0]?.local_body_tax}</Typography>
              <Typography variant="body1" sx={{mb: 1}}>₹ {paymentData[0]?.discount}</Typography>
              <Typography variant="body1" sx={{mb: 1}}>₹ {Number(paymentData[0]?.sgst)+Number(paymentData[0]?.cgst)+Number(paymentData[0]?.igst)}</Typography>
              <Typography variant="h6">₹ {paymentData[0]?.total}</Typography>
          </Grid>
    </Grid>
            </Grid>
        </Grid>
        <Divider sx={{mb: 2}}/>           
        <Grid container sx={{p: 2, pb: 8, background:'#eaeaea'}}>
                  <Grid item xs={6}>
                  <Typography>Signature customer</Typography>
            </Grid>
            <Grid item xs={5} sx={{textAlign:'end'}}>
            <Typography>Signature authority</Typography>
                </Grid>
            </Grid>
      </Box>
    </div>
  );
};

export default Viewquote;